<template>
  <div class="visit">
    <div class="data">
      <el-row :gutter="20">
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            今日推荐数：{{ statisticsData.today }}
          </div></el-col
        >
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            本月推荐数：{{ statisticsData.month }}
          </div></el-col
        >
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            本年度推荐数：{{ statisticsData.year }}
          </div></el-col
        >
      </el-row>
    </div>

    <!-- 搜索框 -->
    <SearchBar @search="search" :checkList="checkList" />

    <!-- 表单 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      @selection-change="handleSelectionChange"
      fit
      highlight-current-row
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <!-- <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column> -->
      <el-table-column label="被推荐人姓名" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.customerName) || '--' }}
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="被推荐人电话"
        align="center"
      >
        <template slot-scope="scope">
          {{
            maskPhoneNumberFun(
              handledecrypt(scope.row.customerPhone),
              scope.row.isShowAllPhone
            ) || '--'
          }}
        </template>
      </el-table-column>
      <el-table-column label="身份证后六位" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.lastSixId || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="物业名称" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.companyName || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="所在城市" align="center">
        <template slot-scope="scope">
          {{ scope.row.areaName || '--' }}
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="推荐物业业态"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.typeName || '--' }}
        </template>
      </el-table-column>
      <el-table-column
        width="180"
        label="推荐物业面积(万平方米)"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.areaSize || '--' }}
        </template>
      </el-table-column>

      <el-table-column width="180" label="推荐时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.appointmentTime || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="推荐人" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.userName) || '--' }}
        </template>
      </el-table-column>

      <el-table-column label="推荐人电话" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.userMobile) || '--' }}
        </template>
      </el-table-column>

      <el-table-column label="备注" align="center">
        <template slot-scope="scope">
          {{ scope.row.remark || '--' }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination ref="Pagination" />
  </div>
</template>

<script>
import { getPmcIntroduceApi, getStatisticsApi } from '@/api/report';
import Pagination from '@/components/Pagination'; // 分页
import { mapGetters } from 'vuex';
import SearchBar from './components/searchBar'; // 搜索框
import { decrypt } from '@/utils/encryp';
import { maskPhoneNumber } from '@/utils/index';

export default {
  components: {
    Pagination,
    SearchBar,
  },
  data() {
    return {
      list: null,
      listLoading: false,
      detailShow: false,
      // size和index用于计算编号
      pageSize: '',
      pageIndex: '',
      checkList: [], // 选中的列表
      statisticsData: {}, // 统计数据
    };
  },
  created() {
    this.fetchData();
    this.getStatistics();
  },

  computed: {
    ...mapGetters(['paginObj']),
  },

  watch: {
    // 当分页组件中页码或页容量发生改变时会重新发请求渲染页面
    paginObj: 'fetchData',
  },
  methods: {
    // 解密
    handledecrypt(str) {
      if (!str) return;
      return decrypt(str);
    },
    maskPhoneNumberFun(str, isShowAllPhone) {
      if (isShowAllPhone) return str;
      return maskPhoneNumber(str);
    },
    // 请求表单数据
    // searchBar会触发此方法
    async fetchData() {
      try {
        this.listLoading = true;
        let res = await getPmcIntroduceApi({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          ...this.fromSearchObj,
        });
        this.listLoading = false;
        if (res.code !== 200 || res.data == null) return;
        let { pageSize, pageIndex, dataList, totalCount } = res.data;
        this.list = dataList;
        this.pageSize = pageSize;
        this.pageIndex = pageIndex;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;
        this.$refs.Pagination.totalCount = totalCount;
      } catch (e) {
        this.listLoading = false;
        window.console.log(e);
      }
    },
    // 获取统计数据
    async getStatistics() {
      try {
        let res = await getStatisticsApi();
        if (res.code !== 200) return;
        this.statisticsData = res.data;
      } catch (error) {
        console.log(error);
      }
    },

    // 搜索
    search(obj = {}) {
      if (obj) this.fromSearchObj = obj;
      // 重置页码
      this.$store.dispatch('area/setPaginObj', {
        pageIndex: 1,
        pageSize: 20,
      });
    },
    handleSelectionChange(val) {
      this.checkList = val.map((item) => {
        return item.pmcId;
      });
    },
  },
};
</script>

<style lang="less">
.visit {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

/deep/ .el-checkbox__input {
  margin-left: 10px;
}

// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}

.btn {
  margin-bottom: 10px;
}

.lookDetails {
  margin-top: 10px;
}

.detail {
  .detail-row {
    margin-top: 10px;
    display: flex;
    font-size: 16px;

    span {
      width: 100px;
      text-align: right;
      margin-right: 20px;
      font-weight: 550;
    }
  }
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 20px;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 60px;
  line-height: 60px;
  text-align: center;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
